"use client";
import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { getContrastTextColor as d } from "./index16.js";
function x({ branding: e, name: s = "Preview", className: t }) {
  const n = {
    "--brand-primary": e.brandPrimary,
    "--brand-accent": e.brandAccent
  }, o = e.brandPrimary ? d(e.brandPrimary) : "#ffffff", i = e.brandAccent ? d(e.brandAccent) : "#ffffff";
  return /* @__PURE__ */ a(
    "div",
    {
      style: n,
      className: `overflow-hidden rounded-xl border border-border bg-surface shadow-sm ${t ?? ""}`,
      children: [
        /* @__PURE__ */ a("div", { className: "flex h-48", children: [
          /* @__PURE__ */ a("div", { className: "flex w-24 flex-col gap-1.5 p-2", style: { backgroundColor: e.brandPrimary }, children: [
            /* @__PURE__ */ a("div", { className: "mb-2 flex items-center gap-1.5 px-1 pt-1", children: [
              e.logoUrl ? /* @__PURE__ */ r("img", { src: e.logoUrl, alt: "Logo", className: "h-4 w-4 rounded object-contain" }) : /* @__PURE__ */ r("div", { className: "h-4 w-4 rounded", style: { backgroundColor: o, opacity: 0.3 } }),
              /* @__PURE__ */ r("span", { className: "truncate text-[9px] font-semibold", style: { color: o, opacity: 0.9 }, children: s })
            ] }),
            ["Overview", "Settings", "Billing"].map((l, c) => /* @__PURE__ */ r(
              "div",
              {
                className: "rounded px-1.5 py-1 text-[8px]",
                style: {
                  backgroundColor: c === 0 ? e.brandAccent : "transparent",
                  color: c === 0 ? i : o,
                  opacity: c === 0 ? 1 : 0.6
                },
                children: l
              },
              l
            ))
          ] }),
          /* @__PURE__ */ a("div", { className: "flex flex-1 flex-col gap-2 bg-surface-raised p-3", children: [
            /* @__PURE__ */ r("div", { className: "h-2 w-20 rounded-full bg-text/10" }),
            /* @__PURE__ */ r("div", { className: "grid grid-cols-2 gap-1.5", children: [0, 1, 2, 3].map((l) => /* @__PURE__ */ a("div", { className: "rounded bg-surface p-1.5 shadow-sm", children: [
              /* @__PURE__ */ r("div", { className: "mb-1 h-1.5 w-8 rounded-full bg-text/10" }),
              /* @__PURE__ */ r("div", { className: "h-3 w-5 rounded-full", style: { backgroundColor: e.brandAccent + "40" } })
            ] }, l)) }),
            /* @__PURE__ */ r("div", { className: "mt-auto flex justify-end", children: /* @__PURE__ */ r(
              "div",
              {
                className: "rounded px-2 py-0.5 text-[7px] font-medium",
                style: { backgroundColor: e.brandPrimary, color: o },
                children: "Save"
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ r("div", { className: "flex border-t border-border", children: [
          { label: "Primary", color: e.brandPrimary },
          { label: "Accent", color: e.brandAccent }
        ].map(({ label: l, color: c }) => /* @__PURE__ */ a("div", { className: "flex flex-1 flex-col items-center gap-1 py-2", children: [
          /* @__PURE__ */ r("div", { className: "h-4 w-4 rounded-full border border-border/50", style: { backgroundColor: c } }),
          /* @__PURE__ */ r("span", { className: "text-[8px] text-text-muted", children: l })
        ] }, l)) })
      ]
    }
  );
}
export {
  x as ThemePreview
};
//# sourceMappingURL=index3.js.map
